module.exports = __webpack_public_path__ + "img/b_16.85d76562.jpg";